import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBus = ({ id, ...data }) => {
  return api.put(`/admin/buses-v2/${id}`, data);
};

export const usePutBusMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putBus,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: ["buses"],
      });
      queryClient.removeQueries({
        queryKey: ["put-bus-simulate"],
      });
    },
    ...restConfig,
  });
};
